import { AxiosResponse } from "axios";
import { GroupUser, Invite, InviteResponse } from "../../store/company-profile/company-profile.types";
import talentApi from "./talent-api-config";


class CompanyProfileApi {
    async fetchGroupUsers(companyId: string): Promise<AxiosResponse<GroupUser[]>> {
        return talentApi.get<GroupUser[]>(`/talent/corporates/${companyId}/users/`);
    }

    async fetchOpenInvites(companyId: string): Promise<AxiosResponse<Invite[]>> {
        return talentApi.get<Invite[]>(`/talent/corporates/${companyId}/invites/`);
    }

    async sendInvite(email: string): Promise<AxiosResponse<InviteResponse>> {
        return talentApi.post<InviteResponse>("/users/talent-invite/", { email });
    }

    async invalidateInvite(key: string): Promise<AxiosResponse<void>> {
        return talentApi.post<void>(`/users/invalidate-talent-invite/`, { key });
    }

    async removeTeamate(id: string, company_id: string): Promise<AxiosResponse<void>> {
        return talentApi.delete(`/talent/corporates/${company_id}/teamate/${id}`);
    }

    async checkEmailDomain(email: string): Promise<AxiosResponse<{ valid: boolean }>> {
        return talentApi.post<{ valid: boolean }>("/invalid-domain/talent/", { email });
    }
}

export const companyProfileApi = new CompanyProfileApi();
